import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';

import { Button, Combobox } from '@salesforce/design-system-react';

import { FlagContext } from '../../../flags/Flags';
import { withSession } from '../../../i18n/containers/AppInit.js';

import './VarietyRulesPanel.scss';

class VarietyRulesPanel extends Component {
  saveRules(session) {
    return () => {
      let variety;
      const selection = this.currentSelection();
      if (selection.length) {
        variety = { attribute: selection[0].value };
      }
      this.props.actions.saveRules(
        {
          ...this.props.rules,
          variety
        },
        { ruleType: 'variety', cToken: session.cToken }
      );
    };
  }

  dirty() {
    return (
      JSON.stringify(this.props.rules.variety) !==
      JSON.stringify(this.props.loadedRules.variety)
    );
  }

  saveAllowed(flags) {
    return !(flags && flags.isReadonly) && this.dirty();
  }

  optionFor(attr) {
    return {
      id: attr.uuid,
      label: attr.name,
      value: attr.name
    };
  }

  options() {
    return this.props.assetAttributes.map(this.optionFor);
  }

  currentSelection() {
    if (this.props.rules?.variety?.attribute) {
      const found = this.props.assetAttributes.find(
        attr => attr.name === this.props.rules.variety.attribute
      );
      if (found) {
        return [this.optionFor(found)];
      }
    }
    return [];
  }

  onSelect(evt, data) {
    this.updateRules(data && data.selection);
  }

  updateRules(selection) {
    let variety = null;

    if (selection && selection.length) {
      variety = { attribute: selection[0].value };
    }

    this.props.actions.updateRules({
      ...this.props.rules,
      variety
    });
  }

  render() {
    const { formatMessage } = this.props.intl;
    const saveRuleLabel = formatMessage({
      id: 'components.ecs.rules.save'
    });
    const cancelRuleLabel = formatMessage({
      id: 'components.ecs.rules.cancel'
    });

    return withSession(session => {
      return (
        <FlagContext.Consumer>
          {flags => (
            <div className="slds-grid slds-wrap">
              <div className="slds-form selection-panel">
                <div className="selection-panel-header">
                  <p>
                    <FormattedMessage id="components.ecs.rules.variety.subHeader" />
                  </p>
                </div>
                <div>
                  <Combobox
                    className="variety-combobox"
                    options={this.options()}
                    selection={this.currentSelection()}
                    events={{ onSelect: this.onSelect.bind(this) }}
                    variant="readonly"
                  />
                </div>
                <div className="footer-button-actions">
                  <Button
                    label={cancelRuleLabel}
                    disabled={!this.saveAllowed(flags)}
                    variant="neutral"
                    onClick={this.props.openUnsavedChangesModal}
                  />
                  <Button
                    id="varietyRulesSaveButton"
                    label={saveRuleLabel}
                    disabled={!this.saveAllowed(flags)}
                    variant="brand"
                    onClick={this.saveRules(session)}
                  />
                </div>
              </div>
            </div>
          )}
        </FlagContext.Consumer>
      );
    });
  }
}

VarietyRulesPanel.propTypes = {
  actions: PropTypes.object,
  assetAttributes: PropTypes.array,
  rules: PropTypes.object,
  loadedRules: PropTypes.object,
  history: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(VarietyRulesPanel);
